/**
 * 财务
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/finance',
  name: '财务',
  component: Layout,
  redirect: '/finance/bills',
  children: [
    {
      path: 'bills',
      name: '销售账单',
      component: () => import('@/views/finance/bills/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'finance_bills'
      }
    },
    {
      path: 'credit',
      name: '信用用户',
      component: () => import('@/views/finance/credit/index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'finance_credit'
      }
    }
  ]
}